module.exports = __webpack_public_path__ + "img/bonus_dark_ru.728fce24.svg";